<template>
    <canvas ref="chart" height="300" width="100"></canvas>
</template>

<script>
import Chart from 'chart.js';
import chartAPI from './../../services/sales/chart';

export default {
    data() {
        return {
            data: [],
            backgroundColors: [" #82e0aa ", " #f8c471 ", " #5d6d7e ", " #2980b9 "],
            chart: null
        }
    },
    computed: {
        datasets() {
            return [{
                label: "Incoming Payments Per Day",
                data: this.data.map(each => ({x: each.day, y: each.total / 1000000})),
                fill: false,
                borderColor: this.backgroundColors[2],
                backgroundColor: "rgba(247, 220, 111, 0.3)",
                tension: 0.3
            }]
        },
        labels() {
            return this.data.map(each => each.day)
        }
    },
    watch: {
        datasets(value) {
            this.chart.data.datasets = value;
            this.chart.data.labels = this.labels;
            this.chart.update();
        }
    },
    methods: {
        renderChart() {
            this.chart = new Chart(this.$refs.chart, {
                type: "line",
                data: {
                    labels: this.labels,
                    datasets: []
                },
                options: {
                    maintainAspectRatio: false,
                    responsive: true,
                    title: {
                        text: "Last Week Payments Per Day (in Millions)",
                        display: true
                    },
                }
            })
        },
        async fetch() {
            let res = await chartAPI.paymentWeekly();
            this.data = res.data;
        }
    },
    mounted() {
        this.renderChart();
        this.fetch();
    },
}
</script>

<style>

</style>

